import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";



export const loadDepartments = async () => {
  try {
    const response = await Axios.get('departments');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadDepartment = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/department');
        const requestData = await response.data;
        return {...requestData, department: {}};
        
      default:
        const respnse = await Axios.get('departments/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useDepartmentAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('departments', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('department_response', responseData.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('departments/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('department_response', responseData.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useDepartmentAPI;


